<template>
  <div class="invoice-config-page">
    <el-card shadow="never" class="config-card">
      <div slot="header" class="card-header">
        <div><h2>自动开票主体配置</h2><p>主体启停只影响新生成的开票任务，已生成任务不追溯变更。</p></div>
        <div class="header-actions">
          <span class="entity-count">共 {{ total }} 个主体</span>
          <el-button icon="el-icon-setting" @click="openSystemDialog">发票系统管理</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="openCreate">新增自动开票主体</el-button>
        </div>
      </div>
      <el-table v-loading="loading" :data="rows" border>
        <el-table-column prop="entity_name" label="主体名称" min-width="180" show-overflow-tooltip />
        <el-table-column prop="seller_tax_no" label="纳税人识别号" min-width="180" />
        <el-table-column label="注册地址 / 电话" min-width="220"><template slot-scope="scope"><div>{{ scope.row.seller_address }}</div><div class="secondary-text">{{ scope.row.seller_phone }}</div></template></el-table-column>
        <el-table-column label="开户行 / 银行账号" min-width="220"><template slot-scope="scope"><div>{{ scope.row.seller_bank_name }}</div><div class="secondary-text">{{ scope.row.seller_bank_account }}</div></template></el-table-column>
        <el-table-column label="支付资质" min-width="190"><template slot-scope="scope"><span v-if="!scope.row.payment_qualifications.length" class="secondary-text">未配置</span><el-tag v-for="item in qualificationSummary(scope.row.payment_qualifications)" :key="item.method" size="mini" class="qualification-tag" :type="item.enabledCount ? '' : 'info'">{{ item.label }}（{{ item.count }}）</el-tag></template></el-table-column>
        <el-table-column label="启用状态" width="105" align="center"><template slot-scope="scope"><el-tag :type="scope.row.auto_invoice_enabled ? 'success' : 'info'">{{ scope.row.auto_invoice_enabled ? '已启用' : '已停用' }}</el-tag></template></el-table-column>
        <el-table-column prop="updated_at" label="更新时间" width="165" />
        <el-table-column label="操作" width="145" fixed="right" align="center"><template slot-scope="scope"><el-button type="text" icon="el-icon-edit" @click="openEdit(scope.row)">编辑</el-button><el-button type="text" @click="toggleEntity(scope.row)">{{ scope.row.auto_invoice_enabled ? '停用' : '启用' }}</el-button></template></el-table-column>
      </el-table>
    </el-card>

    <el-dialog :title="entityForm.id ? '编辑自动开票主体' : '新增自动开票主体'" :visible.sync="entityDialogVisible" width="1000px" top="5vh" :close-on-click-modal="false">
      <el-form ref="entityForm" :model="entityForm" :rules="entityRules" label-width="126px">
        <el-row :gutter="18">
          <el-col :span="12"><el-form-item label="主体名称" prop="entity_name"><el-input v-model.trim="entityForm.entity_name" maxlength="100" placeholder="请输入税务登记主体全称" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="纳税人识别号" prop="seller_tax_no"><el-input v-model.trim="entityForm.seller_tax_no" maxlength="20" placeholder="15、18 或 20 位大写字母和数字" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="注册地址" prop="seller_address"><el-input v-model.trim="entityForm.seller_address" maxlength="200" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="注册电话" prop="seller_phone"><el-input v-model.trim="entityForm.seller_phone" maxlength="30" placeholder="支持数字、空格、短横线和括号" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="开户行" prop="seller_bank_name"><el-input v-model.trim="entityForm.seller_bank_name" maxlength="100" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="银行账号" prop="seller_bank_account"><el-input v-model.trim="entityForm.seller_bank_account" maxlength="32" placeholder="请输入 8-32 位数字" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="启用状态"><el-radio-group v-model="entityForm.auto_invoice_enabled"><el-radio :label="1">启用</el-radio><el-radio :label="0">停用</el-radio></el-radio-group></el-form-item></el-col>
        </el-row>
        <div class="qualification-header"><div><h3>支付资质</h3><p>允许暂不配置；同一支付方式可填写多个不同商户 ID。</p></div><el-button type="primary" plain size="small" icon="el-icon-plus" @click="addQualification">添加支付资质</el-button></div>
        <el-table v-if="entityForm.payment_qualifications.length" :data="entityForm.payment_qualifications" border class="qualification-table">
          <el-table-column label="支付方式" width="135"><template slot-scope="scope"><el-select v-model="scope.row.payment_method" @change="scope.row.merchant_parameter = ''"><el-option v-for="item in paymentMethods" :key="item.value" :label="item.label" :value="item.value" /></el-select></template></el-table-column>
          <el-table-column label="商户参数" min-width="270"><template slot-scope="scope"><el-input v-model.trim="scope.row.merchant_parameter" maxlength="128" :placeholder="merchantPlaceholder(scope.row.payment_method)" /></template></el-table-column>
          <el-table-column label="状态" width="105"><template slot-scope="scope"><el-switch v-model="scope.row.qualification_enabled" :active-value="1" :inactive-value="0" /></template></el-table-column>
          <el-table-column label="备注" min-width="190"><template slot-scope="scope"><el-input v-model.trim="scope.row.remark" maxlength="255" placeholder="选填" /></template></el-table-column>
          <el-table-column label="操作" width="70"><template slot-scope="scope"><el-button type="text" class="danger" @click="removeQualification(scope.$index)">删除</el-button></template></el-table-column>
        </el-table>
        <div v-else class="qualification-empty">暂未配置支付资质</div>
      </el-form>
      <span slot="footer"><el-button @click="entityDialogVisible = false">取消</el-button><el-button type="primary" :loading="entitySaving" @click="submitEntity">保存配置</el-button></span>
    </el-dialog>

    <el-dialog title="发票系统管理" :visible.sync="systemDialogVisible" width="650px" :close-on-click-modal="false">
      <div class="system-alert">这里只维护全局统一的高灯云对接参数，保存后仅影响新的自动开票请求。</div>
      <el-form ref="systemForm" :model="systemForm" :rules="systemRules" label-width="132px">
        <el-form-item label="启用状态"><el-switch v-model="systemForm.system_enabled" :active-value="1" :inactive-value="0" active-text="启用" inactive-text="停用" /></el-form-item>
        <el-form-item label="AppKey" prop="gaodeng_app_key"><el-input v-model.trim="systemForm.gaodeng_app_key" maxlength="100" /></el-form-item>
        <el-form-item label="AppSecret" prop="gaodeng_app_secret"><el-input v-model="systemForm.gaodeng_app_secret" :type="secretVisible ? 'text' : 'password'" maxlength="1000" :placeholder="systemForm.app_secret_configured ? '已配置，留空不修改' : '首次配置时必填'"><el-button slot="append" icon="el-icon-view" @click="secretVisible = !secretVisible" /></el-input><div class="field-tip">密钥不会明文回显；编辑时留空将沿用当前版本。</div></el-form-item>
        <el-form-item label="默认购方邮箱" prop="default_buyer_email"><el-input v-model.trim="systemForm.default_buyer_email" maxlength="100" /></el-form-item>
        <el-form-item label="税收商品名称"><el-input v-model="systemForm.tax_item_name" disabled /></el-form-item>
        <el-form-item label="税收商品编码" prop="tax_item_code"><el-input v-model.trim="systemForm.tax_item_code" maxlength="30" placeholder="仅支持数字" /></el-form-item>
        <el-form-item label="税率" prop="tax_rate"><el-input v-model.trim="systemForm.tax_rate" placeholder="请输入 0-1 之间的小数，例如 0.06" /></el-form-item>
        <el-form-item label="开票员" prop="issuer"><el-input v-model.trim="systemForm.issuer" maxlength="50" /></el-form-item>
        <div v-if="systemForm.config_version" class="config-meta">当前版本：V{{ systemForm.config_version }}；最后更新：{{ systemForm.updated_at || '-' }} {{ systemForm.updated_by_name || '' }}</div>
      </el-form>
      <span slot="footer"><el-button @click="systemDialogVisible = false">关闭</el-button><el-button @click="resetSystemForm">重置</el-button><el-button type="primary" :loading="systemSaving" @click="submitSystem">保存</el-button></span>
    </el-dialog>
  </div>
</template>

<script>
import { getInvoiceEntityConfigs, saveInvoiceEntityConfig, updateInvoiceEntityStatus, getInvoiceSystemConfig, saveInvoiceSystemConfig } from '@/api/invoiceConfig';

const TAX_ITEM_NAME = '信息服务费';

const paymentMethods = [
  { value: 'wechat', label: '微信' },
  { value: 'alipay', label: '支付宝' },
  { value: 'tiktok', label: '抖音' },
];

function emptyEntityForm() {
  return {
    id: null, entity_name: '', seller_tax_no: '', seller_address: '', seller_phone: '',
    seller_bank_name: '', seller_bank_account: '', auto_invoice_enabled: 1, payment_qualifications: [],
  };
}

function emptySystemForm() {
  return {
    config_version: 0, system_enabled: 1, gaodeng_app_key: '', gaodeng_app_secret: '',
    app_secret_configured: false, default_buyer_email: '', tax_item_name: TAX_ITEM_NAME, tax_item_code: '',
    tax_rate: '', issuer: '', updated_at: null, updated_by_name: '',
  };
}

export default {
  name: 'InvoiceEntityConfig',
  data() {
    const validateTaxRate = (rule, value, callback) => {
      if (value === '') return callback(new Error('请输入税率'));
      const number = Number(value);
      if (!Number.isFinite(number) || number < 0 || number > 1) return callback(new Error('税率需填写 0-1 之间的小数'));
      callback();
    };
    const validateSecret = (rule, value, callback) => {
      if (!this.systemForm.app_secret_configured && !value) return callback(new Error('首次配置时 AppSecret 必填'));
      callback();
    };
    return {
      loading: false,
      rows: [],
      total: 0,
      entityDialogVisible: false,
      entitySaving: false,
      entityForm: emptyEntityForm(),
      paymentMethods,
      systemDialogVisible: false,
      systemSaving: false,
      systemForm: emptySystemForm(),
      systemSnapshot: emptySystemForm(),
      secretVisible: false,
      entityRules: {
        entity_name: [{ required: true, message: '请输入主体名称', trigger: 'blur' }],
        seller_tax_no: [
          { required: true, message: '请输入纳税人识别号', trigger: 'blur' },
          { pattern: /^(?:[A-Z0-9]{15}|[A-Z0-9]{18}|[A-Z0-9]{20})$/, message: '须为 15、18 或 20 位大写字母和数字', trigger: 'blur' },
        ],
        seller_address: [{ required: true, message: '请输入注册地址', trigger: 'blur' }],
        seller_phone: [
          { required: true, message: '请输入注册电话', trigger: 'blur' },
          { pattern: /^[0-9\s\-()]+$/, message: '仅支持数字、空格、短横线和括号', trigger: 'blur' },
        ],
        seller_bank_name: [{ required: true, message: '请输入开户行', trigger: 'blur' }],
        seller_bank_account: [
          { required: true, message: '请输入银行账号', trigger: 'blur' },
          { pattern: /^\d{8,32}$/, message: '银行账号须为 8-32 位数字', trigger: 'blur' },
        ],
      },
      systemRules: {
        gaodeng_app_key: [{ required: true, message: '请输入 AppKey', trigger: 'blur' }],
        gaodeng_app_secret: [{ validator: validateSecret, trigger: 'blur' }],
        default_buyer_email: [
          { required: true, message: '请输入默认购方邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' },
        ],
        tax_item_code: [
          { required: true, message: '请输入税收商品编码', trigger: 'blur' },
          { pattern: /^\d{1,30}$/, message: '仅支持 1-30 位数字', trigger: 'blur' },
        ],
        tax_rate: [{ validator: validateTaxRate, trigger: 'blur' }],
        issuer: [{ required: true, message: '请输入开票员', trigger: 'blur' }],
      },
    };
  },
  created() {
    this.loadEntities();
  },
  methods: {
    async loadEntities() {
      this.loading = true;
      try {
        const response = await getInvoiceEntityConfigs();
        const data = response.data.data || {};
        this.rows = data.list || [];
        this.total = Number(data.total || 0);
      } finally {
        this.loading = false;
      }
    },
    qualificationSummary(qualifications) {
      return paymentMethods.reduce((result, method) => {
        const rows = qualifications.filter(item => item.payment_method === method.value);
        if (rows.length) {
          result.push({
            method: method.value,
            label: method.label,
            count: rows.length,
            enabledCount: rows.filter(item => item.qualification_enabled).length,
          });
        }
        return result;
      }, []);
    },
    openCreate() {
      this.entityForm = emptyEntityForm();
      this.entityDialogVisible = true;
      this.$nextTick(() => this.$refs.entityForm && this.$refs.entityForm.clearValidate());
    },
    openEdit(row) {
      this.entityForm = {
        id: row.id,
        entity_name: row.entity_name,
        seller_tax_no: row.seller_tax_no,
        seller_address: row.seller_address,
        seller_phone: row.seller_phone,
        seller_bank_name: row.seller_bank_name,
        seller_bank_account: row.seller_bank_account,
        auto_invoice_enabled: row.auto_invoice_enabled,
        payment_qualifications: (row.payment_qualifications || []).map(item => ({ ...item })),
      };
      this.entityDialogVisible = true;
      this.$nextTick(() => this.$refs.entityForm && this.$refs.entityForm.clearValidate());
    },
    addQualification() {
      this.entityForm.payment_qualifications.push({
        id: null, payment_method: 'wechat', merchant_parameter: '', qualification_enabled: 1, remark: '',
      });
    },
    removeQualification(index) {
      this.entityForm.payment_qualifications.splice(index, 1);
    },
    merchantPlaceholder(method) {
      const placeholders = {
        wechat: '请输入商户ID（mch_id），例如 1735480028',
        alipay: '请输入商户ID（seller_id），例如 2088041315892641',
        tiktok: '请输入商户ID（mchid），例如 6020260509153570',
      };
      return placeholders[method] || '请输入商户 ID';
    },
    validateQualifications() {
      const keys = {};
      for (let index = 0; index < this.entityForm.payment_qualifications.length; index += 1) {
        const item = this.entityForm.payment_qualifications[index];
        if (!item.payment_method) return '第 ' + (index + 1) + ' 条支付资质请选择支付方式';
        if (!/^\d+$/.test(item.merchant_parameter || '')) return '第 ' + (index + 1) + ' 条支付资质的商户 ID 仅支持数字';
        const key = item.payment_method + ':' + item.merchant_parameter;
        if (keys[key]) return '同一支付方式和商户参数不能重复配置';
        keys[key] = true;
      }
      return '';
    },
    submitEntity() {
      this.entityForm.seller_tax_no = this.entityForm.seller_tax_no.toUpperCase();
      this.$refs.entityForm.validate(async valid => {
        if (!valid) return;
        const qualificationError = this.validateQualifications();
        if (qualificationError) {
          this.$message.error(qualificationError);
          return;
        }
        this.entitySaving = true;
        try {
          await saveInvoiceEntityConfig(this.entityForm);
          this.$message.success('保存成功');
          this.entityDialogVisible = false;
          await this.loadEntities();
        } finally {
          this.entitySaving = false;
        }
      });
    },
    toggleEntity(row) {
      const enabled = row.auto_invoice_enabled ? 0 : 1;
      const action = enabled ? '启用' : '停用';
      this.$confirm('确认' + action + '“' + row.entity_name + '”吗？', action + '确认', { type: 'warning' })
        .then(async () => {
          await updateInvoiceEntityStatus(row.id, enabled);
          this.$message.success('已' + action);
          await this.loadEntities();
        })
        .catch(() => {});
    },
    async openSystemDialog() {
      const response = await getInvoiceSystemConfig();
      const data = response.data.data || {};
      this.systemForm = { ...emptySystemForm(), ...data, tax_item_name: TAX_ITEM_NAME, gaodeng_app_secret: '' };
      this.systemSnapshot = { ...this.systemForm };
      this.secretVisible = false;
      this.systemDialogVisible = true;
      this.$nextTick(() => this.$refs.systemForm && this.$refs.systemForm.clearValidate());
    },
    resetSystemForm() {
      this.systemForm = { ...this.systemSnapshot, gaodeng_app_secret: '' };
      this.secretVisible = false;
      this.$nextTick(() => this.$refs.systemForm && this.$refs.systemForm.clearValidate());
    },
    submitSystem() {
      this.$refs.systemForm.validate(async valid => {
        if (!valid) return;
        this.systemSaving = true;
        try {
          await saveInvoiceSystemConfig(this.systemForm);
          this.$message.success('保存成功');
          this.systemDialogVisible = false;
        } finally {
          this.systemSaving = false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.invoice-config-page {
  min-height: calc(100vh - 70px);
  padding: 22px;
  background: linear-gradient(145deg, #f4f7f5, #edf2f4 65%, #e9efeb);
}
.config-card { border: 0; }
.card-header { display: flex; align-items: center; justify-content: space-between; gap: 18px; }
.card-header h2 { margin: 0 0 6px; color: #26352f; font-size: 20px; }
.card-header p { margin: 0; color: #7a8782; font-size: 13px; }
.header-actions { display: flex; align-items: center; gap: 10px; }
.entity-count { color: #7a8782; font-size: 13px; white-space: nowrap; }
.secondary-text { margin-top: 4px; color: #8b9691; font-size: 12px; }
.qualification-tag { margin: 2px 5px 2px 0; }
.qualification-header { display: flex; align-items: center; justify-content: space-between; margin: 8px 0 12px; padding-top: 15px; border-top: 1px solid #edf0ee; }
.qualification-header h3 { margin: 0 0 4px; font-size: 16px; color: #31423b; }
.qualification-header p { margin: 0; color: #8a9590; font-size: 12px; }
.qualification-table { margin-bottom: 8px; }
.qualification-empty { padding: 28px; color: #98a29e; text-align: center; border: 1px dashed #d9dfdc; border-radius: 4px; background: #fafcfb; }
.danger { color: #d45b52; }
.system-alert { margin-bottom: 18px; padding: 12px 14px; color: #6a5a35; background: #fff8e8; border: 1px solid #f1dfb5; border-radius: 4px; }
.field-tip { margin-top: 5px; color: #909b96; font-size: 12px; line-height: 1.5; }
.config-meta { margin-left: 132px; color: #909b96; font-size: 12px; }
@media (max-width: 900px) {
  .invoice-config-page { padding: 12px; }
  .card-header { align-items: flex-start; flex-direction: column; }
  .header-actions { flex-wrap: wrap; }
}
</style>
